<template>
  <div class="container-fluid">
    <Card back>
      <template slot="header">
        <h3>تنظیمات ایمیل</h3>
        <hr />
      </template>
      <template slot="content">
        <div class="row">
          <div class="col-lg-4 col-12 m-3">
            <router-link :to="{ name: 'DetailEmailSetting', params: { status: 'Add' } }" class="btn btn-success w-100"><i class="fas fa-plus"></i> اضافه کردن جدید</router-link>
          </div>
          <div class="col-lg-8 col-12 m-3"></div>
          <div class="col-12 p-2">
            <BnpGrid :action="true" :propsRows="propsRows" :propsColumn="propsColumn" :NoRowNum="true" v-if="$store.state.renderComponentGrid">
              <template slot="action-slot" slot-scope="props">
                <a href="javascript:;" class="mr-2 badge" @click="OnDetail(props.props)"
                  ><h6><span class="fas fa-pen font-weight-bold hover-info"></span></h6
                ></a>
                <a href="javascript:;" class="mr-2 badge" @click="onDelete(props.props)"
                  ><h6><span class="fas fa-trash font-weight-bold hover-danger"></span></h6
                ></a>
              </template>
            </BnpGrid>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
export default {
  data() {
    return {
      propsColumn: [
        { name: 'DisplayName', label: 'نام ایمیل', visibility: true },
        { name: 'SmtpHostName', label: 'هاست smtp', visibility: true },
        { name: 'PopHostName', label: 'هاست   pop3', visibility: true },
      ],
      propsRows: [],
    }
  },
  components: { Card, BnpGrid },
  created() {
    var DataAxiosGEt = { Method: 'Get', Action: 'Email', ArryfildValue: null }
    this.$PostData(DataAxiosGEt)
      .then((result) => {
        if (result.status == 'success') {
          this.propsRows = result.data
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        } else {
          this.$mySweetDefault('عملیات ناموفق', 'مشکلی در ثبت ایمیل بوجود آمده است. اطلاعات خود را بررسی کنید', 'warning', 1500)
        }
      })
      .catch((error) => {
        this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
        console.error('خطا', error)
      })
  },
  methods: {
    OnDetail(data) {
      this.$router.push({ name: 'DetailEmailSetting', params: { status: 'Edit', propsemail: data } })
    },
    Delete(data) {
      var DataAxiosDel = { Method: 'POST', Action: 'Email/DeletetEmail', ArryfildValue: data }
      this.$PostData(DataAxiosDel)
        .then((result) => {
          if (result.status == 'success') {
            this.$mySweetDefaultTost('عملیات موفق', 'ایمیل با موفقیت حذف گردید ', 'success', 1000)
            this.propsRows = result.data
            this.$store.state.renderComponentGrid = false
            this.$nextTick(() => {
              this.$store.state.renderComponentGrid = true
            })
          } else {
            this.$mySweetDefault('عملیات ناموفق', 'مشکلی در حذف ایمیل بوجود آمده است. اطلاعات خود را بررسی کنید', 'warning', 1500)
          }
        })
        .catch((error) => {
          this.$mySweetDefault('خطا ', 'سیستم به حطا رسیده است با برنامه نویس تماس بگیرید', 'error', 1500)
          console.error('خطا', error)
        })
    },
    onDelete(data) {
      this.$SweetQustion('هشدار', 'ایا از حذف ایمیل اطمینان دارید؟', 'info', 'بله', 'انصراف', data, this.Delete, this.cancel)
    },
  },
}
</script>
